import { useTLang } from 'intl/intl';

export function useSFCancelOrderModalLang() {
  return {
    title: useTLang({ id: 'substitutionFlow.002' }),
    paragraph: {
      first: useTLang({ id: 'substitutionFlow.021' }),
      second: useTLang({ id: 'substitutionFlow.022' }),
    },
    action: {
      secondaryBtn: {
        label: useTLang({ id: 'substitutionFlow.023' }),
      },
      primaryBtn: {
        label: useTLang({ id: 'substitutionFlow.024' }),
      },
    },
  };
}
